import React, { useEffect, useState } from "react";
import { getConfirmAlert } from "../../../services/appAlerts";
import { useSelector } from "react-redux";
import { getButtonAlertMessages } from "../../store/layoutUI";

const Button = (props) => {
    const { comp,
        btnProcessStatus,
        isDisabled,
        setIsDisabled,
        isEdit,
        validate,
        doSubmit,
        handleClose,
        size = "btn-sm",
        currentButtonType,
        handleSubformModalShowHide
    } = props;

    const [alertMessages, setAlertMessages] = useState([]);
    const buttonAlertMessagesSelector = useSelector(getButtonAlertMessages);

    useEffect(() => {
        setAlertMessages(buttonAlertMessagesSelector);
    }, [buttonAlertMessagesSelector])

    if (!comp) return null;

    const closeBtn = ["close", "exit", "back"];
    const saveBtn = ["submit", "saveAndContinue", "saveAndExit", "save", "taskCompleted", "checkStatus", "home"];
    const updBtn = ["update", "updateAndContinue", "updateAndExit"];

    const handleEditForm = async () => {
        const result = await getConfirmAlert("Are you sure?", "You want to Edit this Form", "warning");
        if (result.isConfirmed)
            setIsDisabled(false)
    };

    const handleSubmit = async (e) => {
        const targetval = e.currentTarget;
        e.preventDefault();
        const processId = targetval.dataset.process;
        if (parseInt(processId) > 0) {
            const msg = alertMessages.filter(x => x.formProcessId === parseInt(processId));
            if (msg.length > 0) {
                const alMsg = msg[0];
                if (alMsg.isConfirmMessage) {
                    const result = await getConfirmAlert("", alMsg.processItem, "warning");
                    if (result.isConfirmed) {
                        doSubmit(targetval, "Saved Successfully");
                    }
                } else {
                    doSubmit(targetval, alMsg.processItem);
                }
            }
            else {
                doSubmit(targetval, "");
            }
        }
        else {
            doSubmit(targetval, "");
        }
    };

    const getButtonStyleProperties = () => {
        const btnStyle = comp.style || "";
        let btnColor = "#172b4d"; // primary dark blue
        let btnTextColor = "#ffffff";
        let btnBorder = "none";
        const isOutline = btnStyle.includes("outline");

        if (btnStyle.includes("danger")) {
            btnColor = "#ef4444";
        } else if (btnStyle.includes("success")) {
            btnColor = "#22c55e";
        } else if (btnStyle.includes("warning")) {
            btnColor = "#f59e0b";
        } else if (btnStyle.includes("info")) {
            btnColor = "#3b82f6";
        } else if (btnStyle.includes("secondary")) {
            btnColor = "#64748b";
        } else if (btnStyle.includes("dark")) {
            btnColor = "#1e293b";
        }

        if (isOutline) {
            btnTextColor = btnColor;
            btnBorder = `1px solid ${btnColor}`;
            btnColor = "transparent";
        }

        return { btnColor, btnTextColor, btnBorder };
    };

    const { btnColor, btnTextColor, btnBorder } = getButtonStyleProperties();

    if (comp.buttonType?.type === "subform") {
        return (
            <button
                type="button"
                onClick={() => handleSubformModalShowHide && handleSubformModalShowHide("showHide" + comp.subform)}
                className={`${comp?.cssclass ? comp.style + " " + comp.cssclass : comp.style} ${size}`}
                disabled={isDisabled}
            >
                {comp?.formIcons && <i className={`${comp.formIcons} mr-1`} aria-hidden="true"></i>}
                {comp.label}
            </button>
        );
    }

    if (comp.buttonType.type === "editForm") {
        return (
            <button
                type="button"
                name={comp.buttonType.type}
                data-process={comp?.formProcess ? 0 : comp.formProcess}
                className={`form-group ${comp?.cssclass ? comp.style + " " + comp.cssclass : comp.style} ${size}`}
                onClick={isDisabled ? undefined : handleEditForm}
                aria-label={comp.label}
                disabled={isDisabled}
                style={{
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    opacity: isDisabled ? 0.65 : 1
                }}
            >
                {comp?.formIcons && <i className={`${comp.formIcons} mr-2`} aria-hidden="true"></i>}
                {comp.label}
            </button>
        );
    }

    if (comp.buttonType.type === "help") {
        return (
            <button
                type="button"
                name={comp.buttonType.type}
                data-process={comp?.formProcess ? 0 : comp.formProcess}
                className={`${comp?.cssclass ? comp.style + " " + comp.cssclass : comp.style} ${size}`}
                aria-label={comp.label}
                disabled={isDisabled}
                style={{
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    opacity: isDisabled ? 0.65 : 1
                }}
            >
                {comp?.formIcons && <i className={`${comp.formIcons} mr-2`} aria-hidden="true"></i>}
                {comp.label}
            </button>
        );
    }

    if (closeBtn.indexOf(comp.buttonType.type) > -1) {
        return (
            <button
                type="button"
                name={comp.buttonType.type}
                data-process={comp?.formProcess ? 0 : comp.formProcess}
                onClick={handleClose}
                className={`btn ${comp?.cssclass || ""}`}
                style={{
                    fontSize: "14px",
                    fontWeight: 600,
                    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
                    minHeight: "37px",
                    height: "37px",
                    borderRadius: "0px",
                    padding: "0 18px",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    border: "1px solid #172b4d",
                    color: "#172b4d",
                    background: "transparent",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    textTransform: "none",
                    marginRight: "8px",
                    marginBottom: "8px"
                }}
            >
                <i className={`fa ${comp?.formIcons || "fa-times"}`} />
                {comp.label}
            </button>
        );
    }

    if (saveBtn.indexOf(comp.buttonType.type) > -1) {
        const isSaveDisabled = btnProcessStatus || isDisabled || (validate && validate());
        return (!isEdit || isEdit === true || isDisabled) && (
            <button
                type="button"
                name={comp.buttonType.type}
                onClick={handleSubmit}
                data-process={comp?.formProcess}
                data-formid={!comp?.subform ? 0 : comp.subform}
                disabled={isSaveDisabled}
                className={`btn ${comp?.cssclass || ""}`}
                style={{
                    fontSize: "14px",
                    fontWeight: 600,
                    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
                    minHeight: "37px",
                    height: "37px",
                    borderRadius: "0px",
                    padding: "0 18px",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    background: isSaveDisabled ? "#94a3b8" : btnColor,
                    color: isSaveDisabled ? "#ffffff" : btnTextColor,
                    border: isSaveDisabled ? "1px solid #94a3b8" : btnBorder,
                    cursor: isSaveDisabled ? "not-allowed" : "pointer",
                    transition: "all 0.2s ease",
                    textTransform: "none",
                    marginRight: "8px",
                    marginBottom: "8px"
                }}
            >
                {btnProcessStatus && currentButtonType === comp.buttonType.type ? (
                    <i className="fa fa-spinner fa-spin" />
                ) : (
                    ((!btnProcessStatus && comp?.formIcons) || (currentButtonType !== comp.buttonType.type)) && (
                        <i className={`fa ${comp.formIcons}`} />
                    )
                )}
                {comp.label}
            </button>
        );
    }

    if (updBtn.indexOf(comp.buttonType.type) > -1) {
        const isUpdDisabled = btnProcessStatus || (validate && validate());
        return (
            !isEdit && isEdit === false && !isDisabled && (
                <button
                    type="button"
                    name={comp.buttonType.type}
                    data-process={comp?.formProcess ? 0 : comp.formProcess}
                    onClick={handleSubmit}
                    disabled={isUpdDisabled}
                    className={`btn ${comp?.cssclass || ""}`}
                    style={{
                        fontSize: "14px",
                        fontWeight: 600,
                        fontFamily: "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
                        minHeight: "37px",
                        height: "37px",
                        borderRadius: "0px",
                        padding: "0 18px",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        background: isUpdDisabled ? "#94a3b8" : "#172b4d",
                        color: "#ffffff",
                        border: "none",
                        cursor: isUpdDisabled ? "not-allowed" : "pointer",
                        transition: "all 0.2s ease",
                        textTransform: "none",
                        marginRight: "8px",
                        marginBottom: "8px"
                    }}
                >
                    {btnProcessStatus ? (
                        <i className="fa fa-spinner fa-spin" />
                    ) : (
                        comp?.formIcons && <i className={`fa ${comp.formIcons}`} />
                    )}
                    {comp.label}
                </button>
            )
        );
    }

    return null;
}

export default Button;